<template>
  <div class="tw-flex tw-flex-col tw-h-12 tw-items-center tw-justify-center tw-text-center tw-bg-infinity-card-background tw-py-1 tw-px-4 tw-border-t tw-border-0 tw-border-infinity-card-border tw-border-solid">
    <div class="tw-text-sm tw-font-bold tw-text-infinity-card-primary-text tw-truncate tw-w-full">
      <slot name="title"><router-link class="hover:tw-underline" :to="to">{{ title }}</router-link></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    subtitle: {
      type: String,
    },
    title: {
      type: String
    },
    to: {
      type: Object
    }
  }
}
</script>
